import { Component, Input, OnDestroy, OnInit, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'tc-fill-form-first',
    imports: [
        TranslateModule
    ],
    templateUrl: './fill-form-first.component.html',
    styleUrls: ['./fill-form-first.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FillFormFirstComponent {


}
